module.exports = __webpack_public_path__ + "static/media/discount.43cde109.png";